import { Button } from '@mui/material'
import { CustomTableData } from 'common'
import { TooltipInformation } from 'common'
import TooltipAprobacion from 'common/TooltipAprobacion/TooltipAprobacion'
import React from 'react'
import { Edit3, FileText, Info, Trash2 } from 'react-feather'
import { MenuOptions } from './Dropdown'

export const VehicleCatalogTable = ({useFetchInit}) => {

    const {
        FetchData,
        Actions
    }= useFetchInit

    const {fetchAllVehicles: {vehicles} } = FetchData 
    const {handleClickShowInfoVehicle} = Actions

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                    //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                    const {idcontrato, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                    return(
                        <>
                            <TooltipInformation
                                idregistro={idcontrato}
                                usuario_creo={usuario_creo}
                                fecha_creo={fecha_creo}
                                usuario_modifico={usuario_modifico}
                                fecha_modifico={fecha_modifico}
                            />
                        </>
                        
                    )
            }
        },
        { field: "marca", headerName: "MARCA", minWidth: 120, filter: true },
        { field: "linea", headerName: "LINEA", minWidth: 120, filter: true },
        { field: "color", headerName: "COLOR", minWidth: 140, filter: true },
        { field: "modelo", headerName: "MODELO", minWidth: 120, filter: true },
        { field: "matricula", headerName: "MATRICULA", minWidth: 140, filter: true },
        { field: "origen", headerName: "ORIGEN", minWidth: 160, filter: true },
        { 
            field: "disponibilidad",
            headerName: "ESTADO",
            minWidth: 200,
            maxWidth: 200,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellClass: (params) => {

                if(params.value === 'EN CONTRATO') return 'bg-warning';
                if(params.value === 'SOLICITADO') return 'bg-warning';
                if(params.value === 'EN TALLER') return 'bg-warning';
                if(params.value === 'NO DISPONIBLE') return 'bg-danger';
                if(params.value === 'DISPONIBLE') return 'bg-success';
                if(params.value === 'VENDIDO') return 'bg-info';

            },
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const { idvehicle } = params.data
            

                return(
                    <>
                        <Button 
                            startIcon = { <Info/>}
                            variant='contained'
                            size='small' 
                            color='info'
                            sx={{ marginRight: '8px' }}
                            onClick={() => handleClickShowInfoVehicle(idvehicle)} 
                            style={ { width: 150 } }
                            > 
                            Info
                        </Button>
                        <MenuOptions params={params} Actions={Actions}/>
                    </>
                )
                
            }
        },
    ]

    return (
        <div className='content'>
            <CustomTableData 
                rowConfig={vehicles}
                columnConfig={columnConfig}
            />
        </div>
    )
}

